import { html, LitElement, css, unsafeCSS } from 'lit';

import '../components/decklist';
import '../components/comments';

import style from './seed.scss';
import { getNameFromURL, setTitle, trackPage } from '../shared/utils';
export class SeedPage extends LitElement {

    static get properties() {
        return {
        }
    }

    constructor() {
        super();        
        this.seed = '';     
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();
        this.seed = getNameFromURL();       
        setTitle('Seed | '+this.seed);
    }

    render() {                       
        return html`
            <h1><div class="header-image">🎲</div> ${this.seed}</h1>
            <decklist-component url=${`seed/${this.seed}`} showduration="true" title="Decks"></decklist-component> 
            <comments-component path=${window.location.pathname}></comments-component>
        `;
    }
}

customElements.define('seed-page', SeedPage);